export const exportTypes = {
  PNG: 'png',
  JPEG: 'jpeg',
  SVG: 'svg'
};

export function getExportOptions() {

  const shapes = [{
    type: exportTypes.PNG,
    name: 'PNG'
  }, {
    type: exportTypes.JPEG,
    name: 'JPEG'
  }, {
    type: exportTypes.SVG,
    name: 'SVG'
  }];

  return shapes;

}